"use client";

import React, { useState } from "react";
import { useFormik } from "formik";
import { uploadSchema } from "../../../Schema/Schema";
import axiosInstance, { cdnInstance } from "../../../axiosInterceptor";
import { toast } from "react-toastify";

const AddFile = ({callBack}) => {
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null); 

  const formik = useFormik({
    initialValues: {
      type: "",
      image: null,
    },
    validationSchema: uploadSchema,
    onSubmit: async (values, { resetForm }) => {
      if (!values.image) return;
      setLoading(true);

      try {
        const formData = new FormData();
        formData.append("image", values.image);
        const uploadRes = await cdnInstance.post(`/upload-media?label=${values.type}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        const uploadedPath = uploadRes.data;
        const response = await axiosInstance.post("media", {
          type: values.type,
          path: uploadedPath.path,
          name: uploadedPath?.name,
        });

      if(response.status===200){
        toast.success(response.data.message)
        callBack()
         resetForm();
        setPreview(null);
      }
      } catch (error) {
        toast.error(error?.response?.data.message)
      } finally {
        setLoading(false);
      }
    },
  });

  const handleImageChange = (event) => {
    const file = event.currentTarget.files[0];
    formik.setFieldValue("image", file);

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setPreview(null);
    }
  };

  return (
    <form onSubmit={formik.handleSubmit} className="card mb-5">
      <div className="row card-body">
        <div className="col-sm-6 mb-3">
          <label className="col-form-label">Select Type</label>
          <select
            className={`form-control form-control-sm ${
              formik.touched.type && formik.errors.type ? "is-invalid" : ""
            }`}
            name="type"
            value={formik.values.type}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <option value="">Select Type</option>
            <option value="product">PRODUCT</option>
            <option value="catalogue">CATALOGUE</option>
             <option value="other">Other</option>
          </select>
          {formik.touched.type && formik.errors.type && (
            <div className="text-danger">{formik.errors.type}</div>
          )}
        </div>

        <div className="col-sm-6 mb-3">
          <label className="col-form-label">Image</label>
          <input
            type="file"
            className={`form-control form-control-sm border border-dark ${
              formik.touched.image && formik.errors.image ? "is-invalid" : ""
            }`}
            name="image"
            onChange={handleImageChange}
            onBlur={formik.handleBlur}
            accept="image/*"
          />
          {formik.touched.image && formik.errors.image && (
            <div className="text-danger">{formik.errors.image}</div>
          )}

          {/* Image Preview */}
          {preview && (
            <div className="mt-2">
              <img
                src={preview}
                alt="Preview"
                style={{ maxWidth: "100%", maxHeight: "200px" }}
              />
            </div>
          )}
        </div>

        <div className="col-12 text-center">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Uploading..." : "Submit"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default AddFile;
